import { SET_UPDATEINFO_HD } from "../actionTypes";

const initialState = "You can update your information at any time";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_UPDATEINFO_HD: {
      return action.payload;
    }
    default:
      return state;
  }
};
